<template>
    <main>
        <div class="card mb-2" :id="udid">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>{{ link_list.title }}</h3>
                <div class="dashlet-action">
                    <span class="dashlet-refresh" @click="reFreshData()"><i class="fa-solid fa-refresh"></i></span>
                    <span class="dashlet-closed" @click="updateStatus(udid,0)"><i class="fa-solid fa-xmark"></i></span>
                </div>
            </div>
            <div class="card-body" v-if="link_list.customDashlet === undefined || link_list.customDashlet === false">
                <table cellspacing="0" cellpadding="0" class="table m-0 item_table">
                    <thead>
                        <tr>
                            <th>S.No.</th>
                            <th v-for="headItem in metaList" :style="'width:'+headItem.width+'px'">{{headItem.label}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, indexprod) in dataList" :key="indexprod">
                            <td>{{indexprod+1}}</td>
                            <td v-for="headItem in metaList">
                                <router-link :to="link_list.routePath+'/'+item.id+'/detail'" v-if="headItem.link==true">
                                    <span v-if="headItem.columnName==='status'" class="statusDiv"
                                        :class="dom_array.listview_statusColor_dom[item[headItem.columnName]] ? dom_array.listview_statusColor_dom[item[headItem.columnName]] : ''"
                                        v-html="item[headItem.columnName]">
                                        {{item[headItem.columnName]}}
                                    </span>
                                    <span v-else v-html="item[headItem.columnName]">{{item[headItem.columnName]}}</span>
                                </router-link>
                                <template v-else>
                                    <span v-if="headItem.columnName==='status'" class="statusDiv"
                                        :class="dom_array.listview_statusColor_dom[item[headItem.columnName]] ? dom_array.listview_statusColor_dom[item[headItem.columnName]] : ''"
                                        v-html="item[headItem.columnName]">
                                        {{item[headItem.columnName]}}
                                    </span>
                                    <span v-else v-html="item[headItem.columnName]">{{item[headItem.columnName]}}</span>
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else :id="udid">
                <component :is="dynamicComponent" ref="childComponentRef"></component>
            </div>
            <div class="card-footer text-end">
                <router-link :to="link_list.routePath" class="btn btn-secondary btn-sm">View More
                </router-link>
            </div>
        </div>
    </main>
</template>
<script>
    import { ref } from "vue";
    import loader from "@/views/shared/loading/Loading.vue";

    export default {
        name: 'genericDashletTable',
        props: {
            folder: {
                type: String,
                required: true
            },
            module: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            udid: {
                type: String,
                required: true
            },
            updateWidgetsList: '',

        },
        watch: {
            '$props': {
                handler: function (val) {
                    this.loadDashlet();
                },
                deep: true
            }
        },
        components: {
            loader,
        },
        data() {
            return {
                loading: false,
                dynamicComponent: null,
                metaList: [],
                dataList: [],
                link_list: {
                    routePath: '',
                    customDashlet: false,
                },
                //  title: '',
            }
        },
        async mounted() {
            await this.loadDashlet();
            this.dom_array = this.domArrayVariable;
        },
        methods: {
            async loadDashlet() {
                const self = this;
                const modules = this.module;
                const folder = this.folder;
                const title = this.title;
                let searchaArray = require(`@/views/modules/${modules}/dashlets/${folder}/Table.js`);
                self.metaList = searchaArray.default.metaList;

                self.link_list = searchaArray.default.link_list;

                if (typeof title !== 'undefined' && title !== '') {
                    self.link_list.title = title;
                }

                if (self.link_list.customDashlet === undefined || self.link_list.customDashlet === false) {
                    axios.get('api/modules/' + self.link_list.routePath,
                        {
                            params: {
                                page: self.link_list.page,
                                sort: self.link_list.sort,
                                search: self.link_list.search,
                                callingFrom:'dashlet',
                            }
                        }).then(function (response) {
                            self.dataList = response.data.items;
                            self.loading = false;
                        }).catch(function (error) {
                            console.log('error');
                        })
                } else {
                    this.dynamicComponent = (await import(`@/views/modules/${modules}/dashlets/${folder}/custom/${self.link_list.customDashlet}.vue`)).default;
                }
            },
            updateStatus(id, status) {
                const self = this;
                $('#' + id).remove();
                self.customLoading = 'savewidgets';
                axios.post('api/widgets/updatewidgetsstatus', { id: id, status: status }).then(function (response) {
                    self.customLoading = false;
                    var res = response.data;
                    self.updateWidgetsList();
                })
            },
            reFreshData() {
                const self = this;
                if (self.link_list.customDashlet === undefined || self.link_list.customDashlet === false) {
                    self.loadDashlet();
                }else{
                    self.$refs.childComponentRef.customLoadDashlet();
                }
            }
        },


    }
</script>